import {
    FormProvider,
    TextField
  } from '../../components';
  import { Helmet } from 'react-helmet-async'; // Import the async version of Helmet
  import { BackgroundImage, Container} from '../../components';
  import { Box, Button, Stack, Typography } from '@mui/material';
  import { aboutUs as FeedbackAssets } from '../../assets';
  import { useForm } from 'react-hook-form';
  import { yupResolver } from '@hookform/resolvers/yup';
  import * as Yup from 'yup';
  import { useState } from 'react';
  import { useNavigate } from 'react-router-dom';
  
  export const Feedback = () => {
    const navigate = useNavigate();
  
    const [showThankyou, setShowThankyou] = useState(false);
  
    const methods = useForm({
      resolver: yupResolver(
        Yup.object().shape({
          firstName: Yup.string().required('Required'),
          lastName: Yup.string().required('Required'),
          email: Yup.string().email().required('Required'),
          street: Yup.string().required('Required'),
          city: Yup.string().required('Required'),
          zipcode: Yup.number().required('Required'),
          phone: Yup.string()
            .matches(
              /^\+?\d{1,3}?[-.\s]?(\(?\d{1,4}?\)?[-.\s]?)?\d{2,9}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/,
              'Invalid Number'
            )
            .required('Required'),
          hearFrom: Yup.string().required('Required'),
          hasCurrentContract: Yup.bool().required('Required')
        })
      ),
      defaultValues: { interest: [] },
      mode: 'all'
    });
  
    const { handleSubmit } = methods;
  
    const onSubmitHandler = async (formValues) => {
      console.log({ formValues });
      const url = 'https://formkeep.com/f/6f93b5f1166a';
      fetch(url, {
        method: 'POST',
        body: JSON.stringify(formValues),
        headers: {
          Accept: 'application/javascript',
          'Content-Type': 'application/json'
        }
      })
        .then((response) => response.json())
        .then((data) => {
          console.log({ formResponse: data });
          setShowThankyou(true);
        })
        .catch((error) => {
          console.log({ formError: error });
        });
    };
  
    return (
      <>
        <Helmet>
          <title>Feedback Blue Sage Pools - Pool Services & Maintenance in DFW</title>
          <meta
            name="description"
            content="Blue Sage Pools has over 55 years of combined experience providing pool services, maintenance, and construction in DFW and Texas. Contact us today!"
          />
          <meta name="author" content="Blue Sage Pools" />
          <meta property="og:title" content="Feedback Blue Sage Pools - Pool Services & Maintenance" />
          <meta
            property="og:description"
            content="With over 55 years of experience, Blue Sage Pools provides expert pool maintenance, repair, and construction services across DFW and Texas."
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.bluesagepools.com/feedback" />
          <meta property="og:image" content={FeedbackAssets.blueSagePoolLogo} />
          {/* Canonical URL to avoid duplicate content issues */}
          <link rel="canonical" href="https://www.bluesagepools.com/feedback" />
        </Helmet>
  
        <Button
          variant="contained"
          onClick={() => navigate('/schedule-now')}
          sx={{
            p: 1.5,
            position: 'fixed',
            zIndex: '9999',
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0,
            top: '70%',
            transformOrigin: 'left top',
            rotate: '270deg'
          }}
        >
          Schedule Now
        </Button>
        <BackgroundImage
          sx={{ height: '45vh' }}
          src={FeedbackAssets.blueSagePoolCover}
          alt="Blue Sage Pools"
        />
        
        <Container sx={{ textAlign: 'justify' }}>
        <Typography variant="caption">Feedback</Typography>
              <Typography sx={{ my: 4 }} variant="h3">
                We’re Always Striving to Improve
              </Typography>
              
              <Typography variant="paragraph">
               
  If you had anything less than a great experience we would like to hear from you!
              </Typography>
              <Typography variant="paragraph">
              Please inform us about your experience by filling out the form below and we will respond as soon as possible.
              </Typography>
              <FormProvider
                  methods={methods}
                  onSubmit={handleSubmit(onSubmitHandler)}
                  sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}
                >
                  <Stack spacing={2}>
                    <TextField name="Name" label="Name" required />
                    <TextField name="email" label="Email" required />                    
                    <TextField name="phone" label="Phone" required />
                  </Stack>
                                    
                  <TextField name="message" label="Feedback" rows={10} multiline />
                  <Box sx={{ textAlign: 'center' }}>
                    <Button variant="contained" type="submit">
                      Submit
                    </Button>
                  </Box>
                </FormProvider>  
        
        
       
        
         </Container>
        
        <Container sx={{ my: { xs: 5, sm: 10, md: 15 } }}>
          <Box sx={{ maxWidth: '55rem', mx: 'auto' }}>
            {showThankyou ? (
              <>
                <Typography variant="h3" sx={{ my: 4 }} textAlign="center">
                  Thank you!
                </Typography>
                <Typography variant="paragraph" textAlign="center">
                  We received your submission.
                </Typography>
                <Typography variant="paragraph" textAlign="center">
                  We will get back to you shortly.
                </Typography>
                <Box textAlign="center">
                  <Button variant="contained" onClick={() => navigate('/')}>
                    Go back to Home page
                  </Button>
                </Box>
              </>
            ) : (
              <>
              
                
              </>
            )}
          </Box>
        </Container>
        
      </>
    );
  };
  